module.exports = __webpack_public_path__ + "img/title.aced793c.png";